/**
 * GENERATED FILE - DO NOT EDIT.
 *
 * Copied from couponbase-builder/packages/template-renderer/src by
 * `pnpm sync:renderer`. Edit it there and re-run the sync; a drift test fails
 * when this copy and the source disagree.
 */

export {
    buildBreadcrumbCrumbs,
    convertStylesToInline,
    getColumnClasses,
    getColumnFlexStyle,
    getGridClasses,
    getGridStyle,
    getGridWithGapClasses,
    getItemsLayoutStyle,
    getNestedValue,
    hasRenderableValue,
    hasHtmlContent,
    normalizeImageSrc,
    normalizeTemplateItem,
    resolveBoundValue,
    resolveHref,
    resolveImageSrc,
    resolveRepeatedSource,
    resolveTextRules,
    toText,
} from "./resolve";
export type { BreadcrumbCrumb } from "./resolve";

export {
    getLinkBuilderConfig,
    normalizeItem,
    resolveCollection,
    resolveImageUrl,
    resolveSectionMeta,
} from "./collection";
export type { LinkBuilderConfig } from "./collection";

export { safeHref, sanitizeHtml } from "./sanitize";

export type {
    ApiConfig,
    ComponentNode,
    ComponentStyles,
    ComponentType,
    ContentType,
    DataSource,
    GridSize,
    PageJson,
    RenderContext,
    TemplateData,
    TemplateResponse,
} from "./types";
